import { combineReducers } from "redux";
import customerReducer from "./customerReducer";
import customersReducer from "./customersReducer";
import customerTypesReducer from "./customerTypesReducer";
import contactsReducer from "./contactsReducer";
import fieldsReducer from "./fieldsReducer";
import permissionsReducer from "./permissionsReducer";
import itemsReducer from "./itemsReducer";
import valuesReducer from "./valuesReducer";

export default combineReducers({
  customer: customerReducer,
  customers: customersReducer,
  customerTypes: customerTypesReducer,
  contacts: contactsReducer,
  fields: fieldsReducer,
  permissions: permissionsReducer,
  items: itemsReducer,
  values: valuesReducer,
});
